import type { PublicSlotKey } from '@/apilib';
import type { SiteGlobalDataApi } from './siteGlobalDataApi';

export const SiteGlobalDataApiKey: PublicSlotKey<SiteGlobalDataApi> = {
  name: 'SiteGlobalDataApiKey',
  public: true,
};
